import { useOrderByGroupStore } from './order-by-group'
import { useStepperStore } from './stepper'
import { useEmployeesTableStore } from './employeesTable'

type StoreProps = {
  resetAllStores: () => void
}

export const Store = (): StoreProps => {
  const { resetAllData: resetOrderByGroupStore } = useOrderByGroupStore()
  const { resetStepper } = useStepperStore()
  const { resetAllData: resetEmployeesTableStore } = useEmployeesTableStore()

  const resetAllStores = () => {
    resetOrderByGroupStore()
    resetStepper()
    resetEmployeesTableStore()
  }

  return {
    resetAllStores
  }
}
